import Link from 'next/link';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { usePHSTutorialApply } from '@repository/phs/apply/usePhsApply';
import { RouteUrl, V2Route } from '@utils/routeUtil';
import useDebounce from '@utils/hooks/useDebounce';
import UrlUtil from '@utils/urlUtil';
import classnames from 'classnames/bind';
import styles from './gradeButtons.module.scss';

const cx = classnames.bind(styles);

const GradeButtons = () => {
  const { data } = useUserInfo();
  const userName = data?.name ?? '';
  const { mutateAsync: pSTTutorialApplyMutateAsync } = usePHSTutorialApply();

  //튜토리얼 응시 하기 버튼 이벤트
  const onApplyTutorial = useDebounce(async () => {
    const rs = await pSTTutorialApplyMutateAsync({ paccYn: false, pstYn: true });

    UrlUtil.openWindowWithPost(V2Route.getPHSApplyApiPage(rs.url), {
      examCode: rs.code,
      name: userName,
    });
  }, 1000);

  return (
    <div className={cx('btnArea')}>
      <Link href={RouteUrl.PHS_PST_TEST_GATE} legacyBehavior>
        <a className={cx('btn', 'dark')}>재도전 하러가기</a>
      </Link>
      <button className={cx('btn')} onClick={onApplyTutorial}>
        튜토리얼로 연습하기
      </button>
    </div>
  );
};

export default GradeButtons;
